
import FirstSignInStartLinking from "./FirstSignInStartLinking";
import FirstSigninDetailScreen from "./FirstSigninDetailScreen";
import FirstSignInLandingScreen from "./FirstSignInLandingScreen";
import FirstSignInFinishSignup from "./FirstSigninFinishSignup";
import { createStackNavigator } from "@react-navigation/stack";
import React from "react";

const Stack = createStackNavigator();

export default function onboardingNavigationStack() {
    return (
        <>
            <Stack.Screen
                  name="FirstSigninScreen"
                  component={FirstSigninDetailScreen}
                  options={{ title: null, headerShown: false }}
            />
            <Stack.Screen
                  name="FirstSigninLandingScreen"
                  component={FirstSignInLandingScreen}
                  options={{ title: null, headerShown: false }}
            />
            <Stack.Screen
                  name="FirstSignInFinishSignup"
                  component={FirstSignInFinishSignup}
                  options={{ title: null, headerShown: false }}
            />
            <Stack.Screen
                  name="FirstSignInStartLinking"
                  component={FirstSignInStartLinking}
                  options={{ title: null, headerShown: false }}
            />
        </>
    )
}